import React from "react"

import AuthManager from "../utils/AuthManager";
import BulkUploadMappingsTable from "./components/tables/BulkUploadMappings";

export default class BulkUploadMappings extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      currentUser: AuthManager.currentUser
    }
  }

  componentDidMount() {

  }

  render() {
    let {

    } = this.state

    return (
      <>
        <div className="row">
          <div className="col-sm-12 col-xl-12">
            <BulkUploadMappingsTable
              title={"Bulk Upload Mappings"}
            />
          </div>
        </div>
      </>
    )
  }

}
